import { render } from "./DashboardSttp.vue?vue&type=template&id=01a5c181&scoped=true"
import script from "./DashboardSttp.vue?vue&type=script&lang=js"
export * from "./DashboardSttp.vue?vue&type=script&lang=js"

import "./DashboardSttp.vue?vue&type=style&index=0&id=01a5c181&scoped=true&lang=css"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01a5c181"]])

export default __exports__